export interface ILEASE_FORMULA {
  assetValue: number | undefined;
  residualValue: number | undefined;
  leaseTerm: number | undefined;
  interestRate: number | undefined;
}

export const LEASE_FORMULA = ({
  assetValue,
  residualValue,
  leaseTerm,
  interestRate,
}: ILEASE_FORMULA) => {
  if (
    !assetValue ||
    !residualValue ||
    !leaseTerm ||
    !interestRate ||
    Number(assetValue) < 0 ||
    Number(residualValue) < 0 ||
    Number(leaseTerm) < 0 ||
    Number(interestRate) < 0
  ) {
    return {
      monthlyLeasePayments: 0,
      totalPayments: 0,
      totalInterest: 0,
    };
  }
  const PV = Number(assetValue); // present value
  const FV = Number(residualValue); // future value
  const monthlyLeasePayments =
    (PV - FV) / (leaseTerm * 12) + (PV + FV) * (interestRate / 2400);

  const totalPayments = monthlyLeasePayments * leaseTerm * 12;
  const totalInterest = (PV + FV) * (interestRate / 2400) * leaseTerm * 12;
  return {
    monthlyLeasePayments: Number(monthlyLeasePayments).toFixed(2),
    totalPayments: Number(totalPayments).toFixed(0),
    totalInterest: Number(totalInterest).toFixed(0),
  };
};
